import React, {useState, useEffect, useContext} from 'react';
import {TableWrapperContext} from '../../../../../table/new/TableWrapper';
import AddBlogger from '../../../influence/bloggers/list/AddBlogger';
import {Button} from '../../../../../shared/Buttons';
import {CreateAppModal} from '../../../../../../_metronic/partials';
import {TrekerButton} from '../../../influence/bloggers/source/Treker/TrekerButton';

const AddTraffic = ({getBloggersList, type}) => {
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [save, setSave] = useState(false);

  const {presetData, activatePreset, objectToQueryString} = useContext(TableWrapperContext);

  return (
    <>
      <Button
        action={() => {
          setShowCreateAppModal(true);
          setSave(false);
        }}
      >
        <>
          <i className='ki-duotone ki-plus fs-2'></i>Создать
        </>
      </Button>
      <CreateAppModal
        customWidth='mw-550px'
        show={showCreateAppModal}
        handleClose={() => {
          setShowCreateAppModal(false);
        }}
        title={type === 'facebook' ? 'Добавление Кампании' : 'Добавление блогера'}
      >
        <AddBlogger
          setWarning={setWarning}
          warning={warning}
          setSave={setSave}
          save={save}
          show={setShowCreateAppModal}
          getBloggersList={() => activatePreset(objectToQueryString(presetData))}
          isUpdate={false}
          type={type}
        />
      </CreateAppModal>
    </>
  );
};

export default AddTraffic;
